import { createElement, type ComponentPropsWithoutRef, type ElementType } from "react";

import "./AsyncActionFrame.css";

type AsyncActionFrameOwnProps<TComponent extends ElementType> = {
  component?: TComponent;
  active?: boolean;
  attention?: boolean;
  className?: string;
};

export type AsyncActionFrameProps<TComponent extends ElementType = "div"> =
  AsyncActionFrameOwnProps<TComponent>
  & Omit<ComponentPropsWithoutRef<TComponent>, keyof AsyncActionFrameOwnProps<TComponent>>;

export const joinAsyncActionFrameClassNames = (...classNames: Array<string | undefined | false>) =>
  classNames.filter(Boolean).join(" ");

export function AsyncActionFrame<TComponent extends ElementType = "div">({
  component,
  active = false,
  attention = false,
  className,
  ...componentProps
}: AsyncActionFrameProps<TComponent>) {
  const Component = component ?? "div";

  return createElement(Component, {
    ...componentProps,
    "aria-busy": active || undefined,
    className: joinAsyncActionFrameClassNames(
      className,
      (active || attention) && "mq-async-action-frame-pulsing",
    ),
  });
}
